import { render, staticRenderFns } from "./ImportersList.vue?vue&type=template&id=c322691e&scoped=true"
import script from "./ImportersList.vue?vue&type=script&lang=js"
export * from "./ImportersList.vue?vue&type=script&lang=js"
import style0 from "./ImportersList.vue?vue&type=style&index=0&id=c322691e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c322691e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c322691e')) {
      api.createRecord('c322691e', component.options)
    } else {
      api.reload('c322691e', component.options)
    }
    module.hot.accept("./ImportersList.vue?vue&type=template&id=c322691e&scoped=true", function () {
      api.rerender('c322691e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/importers/ImportersList.vue"
export default component.exports